@use '@design/design-tokens/typography/typography' as *;

.tableWrapper {
  width: 100%;
  height: 100%;

  thead {
    th:first-child {
      width: 80px;
    }
  }
}

.tableHeader {
  border-bottom: 1px solid var(--border-default);
  background-color: transparent;
}

.tableCell {
  background-color: transparent;
  padding-top: 8px;
  padding-bottom: 8px;
}

:global(tbody tr:last-child) .tableCell {
  border-bottom: none;
}

.rankFlexRow {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.emptyState {
  padding-top: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.emptyStateText {
  @include typography-v2-body-sm;
  color: var(--text-soft);
}

.emptyTableRow {
  pointer-events: none;
}
